import { useGetHydratedLessonLazyQuery, useGetHydratedLessonQuery } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/LessonChirpService.hooks';
import { GET_HYDRATED_LESSON_QUERY } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/LessonChirpService.dfc.new';
import { updateCache as updateCacheChirp } from '../../utils/DataFetchingClientCache.new';
export const updateLessonCacheChirp = (lessonData, client) => {
  updateCacheChirp(GET_HYDRATED_LESSON_QUERY, () => ({
    lesson: lessonData
  }), {
    lessonId: lessonData.id
  }, client);
};
export const useFullLessonChirp = ({
  lessonId,
  skip,
  fetchPolicy
}) => {
  const {
    loading: lessonLoading,
    data,
    error: lessonError
  } = useGetHydratedLessonQuery({
    variables: {
      lessonId
    },
    skip: skip || lessonId === null || isNaN(lessonId),
    fetchPolicy
  });
  return {
    lesson: data === null || data === void 0 ? void 0 : data.lesson,
    lessonLoading,
    lessonError
  };
};

// Lazy variant of the hydrated-lesson query. Re-exported under the feature's
// name so consumers have one import path; it is the generated lazy hook as-is
// (returns the `[getter, result]` tuple; `onCompleted` receives the raw
// `{ result: { lesson } }` envelope).
export const useFullLessonChirpLazy = useGetHydratedLessonLazyQuery;
export const useLessonContentById = ({
  lessonId,
  contentId,
  fetchPolicy,
  skip
}) => {
  const {
    lesson
  } = useFullLessonChirp({
    lessonId,
    skip,
    fetchPolicy
  });
  if (!lesson) {
    return undefined;
  }
  return lesson.content.find(content => content.id === contentId);
};